import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MobileAppService } from '../services/mobile-app.service';
import Swal from "sweetalert2";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import { LocaleService } from '../services/locale.service';
declare var detect;
@Component({
  selector: 'app-museum-gamepass',
  templateUrl: './museum-gamepass.component.html',
  styleUrls: ['./museum-gamepass.component.scss']
})
export class MuseumGamepassComponent implements OnInit {
  params;
  constructor(private route: ActivatedRoute, private router: Router, private mobileAppService: MobileAppService, private localeService: LocaleService, private http: HttpClient) { }

  generatePassCode() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  isValidBrowser(){

    if(detect){
      let ua = detect.parse(navigator.userAgent);
      
      let isSafari = ua.browser.family.indexOf('Safari') === -1 ? false : true;
      let isChrome = ua.browser.family.indexOf('Chrome') === -1 ? false : true;
      let isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i);
      if(isSamsungBrowser){
        this.dropErrorBrowser();
        return false;
      } else{
        if(isChrome || isSafari){
          return true;
        } else{
          this.dropErrorBrowser();
          return false;
        }
      }
    } else{
     return true;
    }  
  }

  dropErrorBrowser(){
    Swal.fire({
      imageUrl: '../assets/images/walkthrough/6a.png',
      title: this.localeService.getTrans('Not supported browser'),
      text: this.localeService.getTrans("The game only supports Chrome or Safari mobile browsers. "),
      showDenyButton: false,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`Got it`),
      confirmButtonColor: '#4E3B74'
    }).then((result) => {
       this.isValidBrowser();
    });
  }

  dropMaximumNumberOfPlayersError(){
    Swal.fire({
      imageUrl: '../assets/images/walkthrough/6a.png',
      title: this.localeService.getTrans('Maximum number of players reached'),
      text: this.localeService.getTrans("Please contact your program facilitator"),
      showDenyButton: false,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`Got it`),
      confirmButtonColor: '#4E3B74'
    });
  }

  doCheckGameStart(params){
    // IMPORTANT: Always stay on the domain where the user opened the app.
    // This prevents redirects to outdoor.flinkit.io (partner custom domain) on the deployed showcase site.
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const baseURL = window.location.origin + '/';
    const pathPrefix = isLocalhost ? '' : (params.locale ? params.locale + '/' : 'en/');

    let url = baseURL + pathPrefix + 'museum-landing?uid=' + params.uid + '&pc=' + this.generatePassCode() + '&tid=' + params.tid + '&groupId=' + params.groupId + '&type=' + params.type + '&limit=' + params.limit;
    
    if(params.showcase === 'true' || params.showcase === true || params.showcase === '1'){
      url += '&showcase=true';
    }
    
    const hasVirtual = params.hasOwnProperty('virtual') && 
                      params.virtual !== 'false' && 
                      params.virtual !== false && 
                      params.virtual !== null && 
                      params.virtual !== undefined;
    if(hasVirtual){
      url += '&virtual=true';
    }
    
    if(params.isAirbnb === 'true' || params.isAirbnb === true){
      url += '&isAirbnb=true';
    }
    
    window.location.href = url;
  
  
  }



  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      console.log('museum-gamepass params:', params);
      console.log('showcase value:', params.showcase, 'type:', typeof params.showcase);
      console.log('virtual value:', params.virtual, 'type:', typeof params.virtual);
      this.params = params;
      if (!params.uid) {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const redirectURL = isLocalhost ? window.location.origin + '/' : this.mobileAppService.getURL();
        window.location.href = redirectURL;
      }

      if(params.validity && params.validity.length === 10){
        if(moment(params.validity).isBefore(moment())){
          window.location.href = '/en/hello';
        } else{
          this.doCheckGameStart(params);
        }
      } else{
        this.doCheckGameStart(params);
      }
   
     /*    if (params.uid && params.tid && params.type && params.groupId && params.limit) {
          if(this.isValidBrowser()){
            this.http.post(environment.baseUrl + 'games/countGamesByGroupId', {
              groupId: params.groupId
            }
          ).subscribe((data: any) => {
           
            if((data.msg >= parseInt(params.limit)) && parseInt(params.limit) > 0){
              this.dropMaximumNumberOfPlayersError();
            } else{

            
              if(params.validity && params.validity.length === 10){
                if(moment(params.validity).isBefore(moment())){
                  window.location.href = '/en/hello';
                } else{
                  this.doCheckGameStart(params);
                }
              } else{
                this.doCheckGameStart(params);
              }

             
            }
          });
          }
        } */

      });
    
  }

}
